// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file general/hair_color.proto (package protos.general, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file general/hair_color.proto.
 */
export const file_general_hair_color: GenFile = /*@__PURE__*/
  fileDesc("ChhnZW5lcmFsL2hhaXJfY29sb3IucHJvdG8SDnByb3Rvcy5nZW5lcmFsKsICCglIYWlyQ29sb3ISFgoSSEFJUl9DT0xPUl9VTktOT1dOEAASFwoTSEFJUl9DT0xPUl9NQUhPR0FOWRABEhUKEUhBSVJfQ09MT1JfQVVCVVJOEAISFAoQSEFJUl9DT0xPUl9XSElURRADEhUKEUhBSVJfQ09MT1JfQkxPTkRFEAQSGQoVSEFJUl9DT0xPUl9SRURfQkxPTkRFEAUSFAoQSEFJUl9DT0xPUl9CUk9XThAGEhcKE0hBSVJfQ09MT1JfQ0hFU1ROVVQQBxITCg9IQUlSX0NPTE9SX0dSQVkQCBIUChBIQUlSX0NPTE9SX0JMQUNLEAkSHgoaSEFJUl9DT0xPUl9TQUxUX0FORF9QRVBQRVIQChISCg5IQUlSX0NPTE9SX1JFRBALEhcKE0hBSVJfQ09MT1JfUkVEX0hBSVIQDGIGcHJvdG8z");

/**
 * @generated from enum protos.general.HairColor
 */
export enum HairColor {
  /**
   * @generated from enum value: HAIR_COLOR_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: HAIR_COLOR_MAHOGANY = 1;
   */
  MAHOGANY = 1,

  /**
   * @generated from enum value: HAIR_COLOR_AUBURN = 2;
   */
  AUBURN = 2,

  /**
   * @generated from enum value: HAIR_COLOR_WHITE = 3;
   */
  WHITE = 3,

  /**
   * @generated from enum value: HAIR_COLOR_BLONDE = 4;
   */
  BLONDE = 4,

  /**
   * @generated from enum value: HAIR_COLOR_RED_BLONDE = 5;
   */
  RED_BLONDE = 5,

  /**
   * @generated from enum value: HAIR_COLOR_BROWN = 6;
   */
  BROWN = 6,

  /**
   * @generated from enum value: HAIR_COLOR_CHESTNUT = 7;
   */
  CHESTNUT = 7,

  /**
   * @generated from enum value: HAIR_COLOR_GRAY = 8;
   */
  GRAY = 8,

  /**
   * @generated from enum value: HAIR_COLOR_BLACK = 9;
   */
  BLACK = 9,

  /**
   * @generated from enum value: HAIR_COLOR_SALT_AND_PEPPER = 10;
   */
  SALT_AND_PEPPER = 10,

  /**
   * @generated from enum value: HAIR_COLOR_RED = 11;
   */
  RED = 11,

  /**
   * @generated from enum value: HAIR_COLOR_RED_HAIR = 12;
   */
  RED_HAIR = 12,
}

/**
 * Describes the enum protos.general.HairColor.
 */
export const HairColorSchema: GenEnum<HairColor> = /*@__PURE__*/
  enumDesc(file_general_hair_color, 0);

